import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/local-communities/LocalCommunities.tsx");
